import { Component } from '@angular/core';

@Component({
  selector: 'rid-mechanic-content',
  imports: [],
  templateUrl: './rid-mechanic-content.html',
  host: {
    class: 'contents',
  },
})
export class RidMechanicContent {}
